import type { MisconceptionDefinition } from './types'
import { coordinatenMisconceptions } from './met/coordinaten'
import { cirkelMisconceptions } from './met/cirkel'
import { hoekMisconceptions } from './met/hoek'
import { oppervlakteMisconceptions } from './met/oppervlakte'
import { inhoudMisconceptions } from './met/inhoud'
import { lengteMisconceptions } from './met/lengte'
import { gewichtMisconceptions } from './met/gewicht'

/** MET — Metriek misconcepties. */
export const MET_MISCONCEPTIONS: MisconceptionDefinition[] = [
  ...coordinatenMisconceptions,
  ...cirkelMisconceptions,
  ...hoekMisconceptions,
  ...oppervlakteMisconceptions,
  ...inhoudMisconceptions,
  ...lengteMisconceptions,
  ...gewichtMisconceptions,
]
